import React from "react";
import "./FormFields.css";

const CheckboxField = ({
  label,
  checked,
  onChange,
  description = "",
  style = {},
  className = "",
  labelStyle = {},
  checkboxStyle = {},
  descriptionStyle = {},
  disabled = false,
  ...props
}) => {
  const labelClassName = "form-checkbox-field";
  const checkboxClassName = "form-checkbox";
  const descriptionClassName = "form-checkbox-description";

  // For disabled checkboxes, use a custom styled div to ensure exact color control
  const isDisabled = disabled || props.disabled;

  return (
    <div className={`form-group ${className}`} style={style}>
      <label className={labelClassName} style={labelStyle}>
        {isDisabled ? (
          <span
            className={`${checkboxClassName} custom-disabled-checkbox ${checked ? "checked" : ""}`}
            style={{
              width: "12px",
              height: "12px",
              display: "inline-block",
              border: "1px solid #6c757d",
              borderRadius: "2px",
              backgroundColor: checked ? "#6c757d" : "transparent",
              position: "relative",
              marginRight: "8px",
              verticalAlign: "middle",
              cursor: "not-allowed",
            }}
          >
            {checked && (
              <span
                style={{
                  position: "absolute",
                  left: "3px",
                  top: "0px",
                  width: "4px",
                  height: "7px",
                  border: "solid white",
                  borderWidth: "0 2px 2px 0",
                  transform: "rotate(45deg)",
                }}
              />
            )}
          </span>
        ) : (
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className={checkboxClassName}
            style={{ width: "12px", height: "12px" }}
            disabled={disabled}
            {...props}
          />
        )}
        {description && (
          <span className={descriptionClassName} style={descriptionStyle}>
            {description}
          </span>
        )}
        {!description && label}
      </label>
    </div>
  );
};

export default CheckboxField;
